import { ENV } from '@/constants';
import { exploreSchemaItemList } from '../exploreSchema';

export const schemaObject_Upscaler = {
	'@context': 'https://schema.org',
	'@graph': [
		{
			'@type': 'WebPage',
			'@id': 'https://liftapp.ai/image-upscaler',
			name: 'Instant AI Image Upscaler | Sharpen Blurry Photos HD | Lift',
			description:
				'Enlarge small or pixelated images up to 4K in seconds. Online AI photo upscaler, no watermarks. Try Lift Upscaler now.',
			image: 'https://liftapp.ai/seo-image.webp',
			mainEntity: [
				{ '@id': 'https://liftapp.ai/image-upscaler#product' },
				{ '@id': 'https://liftapp.ai/image-upscaler#howto' },
				{ '@id': 'https://liftapp.ai/image-upscaler#benefits' },
				{ '@id': 'https://liftapp.ai/image-upscaler#faq' },
				{ '@id': 'https://liftapp.ai/image-upscaler#why-lift' },
				{ '@id': 'https://liftapp.ai/image-upscaler#explore-tools' },
				{ '@id': 'https://liftapp.ai/image-upscaler#all-in-one' },
			],
		},
		// product
		{
			'@type': 'Product',
			'@id': 'https://liftapp.ai/image-upscaler#product',
			name: 'Instant AI Image Upscaler',
			description:
				'Enlarge small or pixelated images up to 4K in seconds. Online AI photo upscaler, no watermarks.',
			url: 'https://liftapp.ai/image-upscaler',
			fileFormat: ['image/jpeg', 'image/png', 'image/webp'],
			memoryRequirements: 'Max file size: 20MB',
			brand: {
				'@type': 'Brand',
				name: 'Lift',
			},
			aggregateRating: {
				'@type': 'AggregateRating',
				ratingValue: '4.8',
				reviewCount: 130000,
				bestRating: '5',
				worstRating: '1',
			},
			interactionStatistic: [
				{
					'@type': 'InteractionCounter',
					interactionType: { '@type': 'InstallAction' },
					userInteractionCount: 13000000,
				},
			],
		},
		// howto
		{
			'@type': 'HowTo',
			'@id': 'https://liftapp.ai/image-upscaler#howto',
			name: 'How it works',
			step: [
				{
					'@type': 'HowToStep',
					position: 1,
					name: 'Upload your image',
					text: 'Choose a photo from your device or take one using Lift’s app',
				},
				{
					'@type': 'HowToStep',
					position: 2,
					name: 'Let AI upscale it',
					text: 'Lift’s AI increases resolution while preserving textures and edges',
				},
				{
					'@type': 'HowToStep',
					position: 3,
					name: 'Customize adjustments',
					text: 'Fine-tune your image with easy-to-use editing tools',
				},
				{
					'@type': 'HowToStep',
					position: 4,
					name: 'Download and use',
					text: 'Download your image or publish it straight to your social feeds',
				},
			],
		},
		// benefits
		{
			'@type': 'ItemList',
			'@id': 'https://liftapp.ai/image-upscaler#benefits',
			name: 'Who can benefit from Image Upscaler?',
			description:
				'Lift AI Image Upscaler helps e-commerce sellers, content creators, marketers, and more improve image quality instantly with AI retouching.',
			itemListOrder: 'Unordered',
			itemListElement: [
				{
					'@type': 'ListItem',
					position: 1,
					name: 'AI Upscaling is ideal for anyone needing clearer, larger visuals in no time',
				},
				{
					'@type': 'ListItem',
					position: 2,
					name: 'Online sellers can present products in high resolution for a polished storefront',
				},
				{
					'@type': 'ListItem',
					position: 3,
					name: 'Photographers can enlarge older or cropped images without losing quality',
				},
				{
					'@type': 'ListItem',
					position: 4,
					name: 'Content creators and marketers can boost visual impact across platforms and formats',
				},
				{
					'@type': 'ListItem',
					position: 5,
					name: 'AI Image Upscaler bridges the gap between quick fixes and professional-quality results, making it indispensable for both personal and professional use',
				},
			],
			image: {
				'@type': 'ImageObject',
				contentUrl:
					'https://liftapp.ai/_next/static/media/benefits.d4ac6242.webp',
				name: 'Stylized portrait and scratch removal',
				description: 'AI-upscaled example showing before/after retouch by Lift',
			},
		},
		// faq
		{
			'@type': 'FAQPage',
			'@id': 'https://liftapp.ai/image-upscaler#faq',
			mainEntity: [
				{
					'@type': 'Question',
					name: 'What is Lift AI Upscaler?',
					acceptedAnswer: {
						'@type': 'Answer',
						text: 'Lift AI Upscaler is a premium online tool that increases your image resolution up to 4× without losing sharpness or quality — perfect for printing, e-commerce or HD displays.',
					},
				},
				{
					'@type': 'Question',
					name: 'How does Lift AI Upscaler work?',
					acceptedAnswer: {
						'@type': 'Answer',
						text: 'AI Upscaler uses advanced super-resolution technology to rebuild pixel details and sharpen edges while preserving natural textures. Everything happens in the cloud — just upload, choose your scale (2× or 4×), and get stunning results in seconds.',
					},
				},
				{
					'@type': 'Question',
					name: 'Can it upscale an image to 4K?',
					acceptedAnswer: {
						'@type': 'Answer',
						text: 'Yes. Upload a photo up to 20MB, select the 4× option, and Lift will generate a crisp 4K PNG or JPG — ideal for high-resolution needs.',
					},
				},
				{
					'@type': 'Question',
					name: 'Can I download the results without a watermark?',
					acceptedAnswer: {
						'@type': 'Answer',
						text: "Absolutely. All images generated or edited in Lift can be exported without watermark when you're on the Pro plan. Download them in high-res PNG or JPG — ready for social media, print, ads, or e-commerce.",
					},
				},
			],
		},
		// why-lift
		{
			'@type': 'ItemList',
			'@id': 'https://liftapp.ai/image-upscaler#why-lift',
			name: 'Why Lift’s AI upscaling stands out',
			description:
				"Discover the advantages of Lift's AI-powered image upscaling: professional quality, tailored AI enhancement, seamless multi-platform access, and affordability.",
			itemListOrder: 'Unordered',
			itemListElement: [
				{
					'@type': 'ListItem',
					position: 1,
					name: 'Professional results',
					description:
						'Achieve studio-quality images without the need for complex tools',
				},
				{
					'@type': 'ListItem',
					position: 2,
					name: 'AI accuracy',
					description:
						'Smart algorithms deliver enhancements tailored to your specific image',
				},
				{
					'@type': 'ListItem',
					position: 3,
					name: 'Cross-platform support',
					description: 'Available on iOS, Android, and Web for seamless access',
				},
				{
					'@type': 'ListItem',
					position: 4,
					name: 'Budget-friendly',
					description:
						'Save on costly editing services with Lift’s affordable solution',
				},
			],

			image: {
				'@type': 'ImageObject',
				contentUrl:
					'https://liftapp.ai/_next/static/media/whyLift.b11abf6c.webp',
				name: 'Before and after with Lift',
				description:
					'Visual comparison of original vs AI-enhanced image quality using Lift.',
			},
		},
		// explore
		{
			'@type': 'ItemList',
			'@id': 'https://liftapp.ai/image-upscaler#explore-tools',
			name: 'Explore the AI tools',
			description:
				'A curated list of AI-powered tools for image generation, enhancement, background removal, and more – all available on Lift.',
			itemListOrder: 'Unordered',
			...exploreSchemaItemList,
		},
		// all-in-one
		{
			'@type': 'SoftwareApplication',
			'@id': 'https://liftapp.ai/image-upscaler#all-in-one',
			name: 'Try Lift – AI Content Creation Tools',
			description:
				'Your all-in-one tools to create, edit, and elevate your content. Create stunning content with AI tools, templates, and editing features effortlessly.',
			operatingSystem: 'iOS, Android, Web',
			applicationCategory: 'MultimediaApplication',
			url: `${ENV.LIFT_WEB_APP_URL}/sign-in?auto_login=true`,
			applicationSubCategory: 'Content Creation',
			publisher: {
				'@type': 'Organization',
				name: 'Lift',
				url: 'https://liftapp.ai',
			},
			potentialAction: [
				{
					'@type': 'ViewAction',
					name: 'Open Web App',
					target: `${ENV.LIFT_WEB_APP_URL}/sign-in?auto_login=true`,
				},
			],
		},

		{
			'@type': 'BreadcrumbList',
			itemListElement: [
				{
					'@type': 'ListItem',
					position: 1,
					name: 'Home',
					item: 'https://liftapp.ai',
				},
				{
					'@type': 'ListItem',
					position: 2,
					name: 'Image Upscaler',
					item: 'https://liftapp.ai/image-upscaler',
				},
			],
		},
	],
};
